import { useQuery } from '@tanstack/react-query'
import { jsonFetch } from '@/lib/api/jsonFetch'
import type { InventoryResponse } from './types'

export function useInventory(limit = 500) {
  return useQuery({
    queryKey: ['inventory', 'list', limit],
    queryFn: () =>
      jsonFetch<InventoryResponse>(
        `/api/reports/inventory?${new URLSearchParams({ limit: String(limit) }).toString()}`,
      ),
    staleTime: 30_000,
  })
}
